import {ProductCollectionsEnum} from "../../shared/enums/product-collections.enum";

export class SuggestionsSearchModel {
    public constructor(
        public collection: ProductCollectionsEnum,
        public field: string,
        public search: string,
        public maxRows: number = 999
    ) {
    }
}
